// Prikazno ime stanice: „Bor AS (Bor)". Lokacija se izostavlja kad je ista kao
// naziv stanice (izbegava „Beograd (Beograd)") i kad je izvor bez lokacije
// (stara pretraga / sačuvan izbor iz starijih sesija).
export default function stationLabel(option) {
    if (!option) return "";
    const name = option.name || "";
    const location = option.locationName || option.location?.name || "";
    if (!location || location === name) return name;
    return `${name} (${location})`;
}
